export default __webpack_public_path__ + "788549b406000436a2ca17ba105a57ca.png";